import {
    Button,
    Col,
    Form,
    Input,
    Label,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane
} from 'reactstrap';
import TabOne from './TabOne';
import TabTwo from './TabTwo';
import TabThree from './TabThree';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../../../../ReduxToolkit/Hooks';
import { City, Href, SKU, StockAvailability } from '../../../../../../utils/Constant';
import { setTabId } from '../../../../../../ReduxToolkit/Reducers/AddProductSlice';
import { productFiveNavData } from '../../../../../../Data/Application/Ecommerce/AddProduct';
import CommonButton from '../CommonButton/CommonButton';

const ProductFive = ({
    in_stock,
    sku,
    zip_code,
    city,
    weight,
    shipping_class,
    setProductDetail,
    brand,
    fabric,
    seller
}: {
    in_stock?: boolean;
    sku?: string;
    zip_code?: number;
    city?: string;
    weight?: number;
    shipping_class?: string;
    setProductDetail: any;
    brand?: string;
    fabric?: string;
    seller?: string;
}) => {
    const { tabId } = useAppSelector((state) => state.addProduct);
    const dispatch = useDispatch();
    return (
        // <div className="sidebar-body advance-options">
        //   <Nav className="border-tab mb-0" tabs>
        //     {productFiveNavData.map((data,i)=>(
        //       <NavItem key={i} >
        //         <NavLink active={tabId === i+1 ? true : false} onClick={()=>dispatch(setTabId(i+1))} href={Href}>
        //           {data}
        //         </NavLink>
        //       </NavItem>
        //     ))}
        //   </Nav>
        //   <TabContent activeTab={tabId}>
        //     <TabPane tabId={1} >
        //       <TabOne/>
        //     </TabPane>
        //     <TabPane tabId={2} >
        //       <TabTwo />
        //     </TabPane>
        //     <TabPane tabId={3} >
        //       <TabThree />
        //     </TabPane>
        //   </TabContent>
        // </div>

        <div className="sidebar-body">
            <Form style={{ height: '100%' }}>
                <Row className="g-2">
                    <Col sm="6">
                        <Label>{StockAvailability}</Label>
                        <Input
                            type="select"
                            name="stock"
                            value={in_stock ? 1 : 0}
                            onChange={(e) =>
                                setProductDetail({
                                    in_stock: Number(e.target.value) == 1 ? true : false
                                })
                            }>
                            <option value={1}>{'In stock'}</option>
                            <option value={0}>{'Out of stock'}</option>
                        </Input>
                    </Col>
                    <Col sm="6">
                        <Label>{SKU}</Label>
                        <Input
                            type="text"
                            name="sku"
                            value={sku}
                            onChange={(e) => setProductDetail({ sku: e.target.value })}
                        />
                    </Col>
                    <Col sm="6">
                        <Label>{'Brand'}</Label>
                        <Input
                            type="text"
                            name="sku"
                            value={brand}
                            onChange={(e) => setProductDetail({ brand: e.target.value })}
                        />
                    </Col>
                    <Col sm="6">
                        <Label>{'Fabric'}</Label>
                        <Input
                            type="text"
                            name="sku"
                            value={fabric}
                            onChange={(e) => setProductDetail({ fabric: e.target.value })}
                        />
                    </Col>
                    <Col sm="6">
                        <Label>{'Seller'}</Label>
                        <Input
                            type="text"
                            name="sku"
                            value={seller}
                            onChange={(e) => setProductDetail({ seller: e.target.value })}
                        />
                    </Col>
                    <Col sm="6">
                        <Label>{'Zip code'}</Label>
                        <Input
                            type="text"
                            name="zipcode"
                            value={zip_code}
                            onChange={(e) => setProductDetail({ zip_code: e.target.value })}
                        />
                    </Col>
                    <Col sm="6">
                        <Label>{City}</Label>
                        <Input
                            type="text"
                            name="city"
                            value={city}
                            onChange={(e) => setProductDetail({ city: e.target.value })}
                        />
                    </Col>

                    <Col sm="6">
                        <Label>{'Weight'}</Label>
                        <Input
                            type="text"
                            name="zipcode"
                            value={weight}
                            onChange={(e) => setProductDetail({ weight: e.target.value })}
                        />
                    </Col>
                    <Col sm="6">
                        <Label>{'Shipping Class'}</Label>
                        <Input
                            type="select"
                            name="inputState"
                            value={shipping_class}
                            onChange={(e) => setProductDetail({ shipping_class: e.target.value })}>
                            <option value={'Basic Shipping'}>{'Basic Shipping'}</option>
                            <option value={'Expedited Shipping'}>{'Expedited Shipping'}</option>
                            <option value={'International Shipping'}>
                                {'International Shipping'}
                            </option>
                            <option value={'Free Shipping'}>{'Free Shipping'}</option>
                            <option value={'Same-Day or Next-Day Shipping'}>
                                {'Same-Day or Next-Day Shipping'}
                            </option>
                            <option value={'Flat Rate Shipping'}>{'Flat Rate Shipping'}</option>
                            <option value={'Local Pickup'}>{'Local Pickup'}</option>
                        </Input>
                    </Col>
                </Row>
            </Form>
        </div>
    );
};

export default ProductFive;
